export default __webpack_public_path__ + "static/media/spring-framework.fa400041.png";